// extracted by mini-css-extract-plugin
export default {"TeamsAndScoreContainer":"TeamsAndScore_TeamsAndScoreContainer__scUxX","TeamsContainer":"TeamsAndScore_TeamsContainer__12h8Z"};